import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class MergeTranscriptSpeakers {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly speakerId: number,
		public readonly intoSpeakerId: number,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			intoSpeakerId: this.intoSpeakerId,
		};
	}
}

export default MergeTranscriptSpeakers;
